import { ImageScanOverlay } from '../ImageScanOverlay';
import type { ImageSearchResultType } from '../../types/type';
import CenterScreenWrapper from '../CenterScreenWrapper';
import { t } from 'i18next';
import { useDotAnimation } from '../../../hooks/useDotAnimation';

export default function ImageSearchLoading({
  imageData,
  selectedMember,
  isLoading,
  onBackClick
}: {
  imageData: string;
  selectedMember: ImageSearchResultType['selectedMember'];
  isLoading: boolean;
  onBackClick: () => void;
}) {
  const dots = useDotAnimation({ isLoading });
  return (
    <CenterScreenWrapper>
      <div className="flex flex-col justify-start items-center gap-[20px]">
        <ImageScanOverlay
          imageData={imageData}
          selectedMember={selectedMember}
          isLoading={isLoading}
          isPhotoCardRatio={false}
        />
        <div className="flex flex-col items-center gap-[14px] px-[24px] justify-center">
          <p className="text-pure-black text-[26px] font-bold dark:text-main-dark-1 text-center">
            {t('imageSearch.loading.title')}
          </p>
          <p className="text-main-light-4 text-[15px] font-medium dark:text-main-dark-4 text-center">
            {t('imageSearch.loading.description', { dots })}
          </p>
        </div>
        <div className="h-[20vh]" />
      </div>
    </CenterScreenWrapper>
  );
}